export const HeartRateLevel = (heartrate, t) => {
  let result = '';
  let color = '';

  if (heartrate <= 59) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (heartrate >= 60 && heartrate <= 100) {
    result = `${t('normal')}`;
    color = 'normal';
  } else if (heartrate > 100) {
    result = `${t('severe')}`;
    color = 'severe';
  }
  return { result, color };
};

export const TemperatureLevel = (temperature, t) => {
  let result = '';
  let color = '';
  if (temperature <= 36.4) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (temperature >= 36.5 && temperature <= 37.5) {
    result = `${t('normal')}`;
    color = 'normal';
  } else if (temperature >= 37.6 && temperature <= 38.5) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (temperature >= 38.6 && temperature <= 39.5) {
    result = `${t('severe')}`;
    color = 'severe';
  } else if (temperature >= 39.6) {
    result = `${t('severe')}`;
    color = 'severe';
  }
  return { result, color };
};

export const SpO2Level = (spo2, t) => {
  let result = '';
  let color = '';
  if (spo2 <= 87) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (spo2 >= 88 && spo2 <= 94) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (spo2 >= 95 && spo2 <= 100) {
    result = `${t('normal')}`;
    color = 'normal';
  } else if (spo2 > 100) {
    result = `${t('severe')}`;
    color = 'severe';
  }
  return { result, color };
};

export const BloodPressureLevel = (systolic, diastolic, t) => {
  let result = '';
  let color = '';
  if (systolic === 0 || diastolic === 0) {
    result = '';
    color = '';
  } else if (systolic <= 119 || diastolic <= 79) {
    result = `${t('normal')}`;
    color = 'normal';
  } else if (systolic <= 129 || diastolic <= 84) {
    result = `${t('normal')}`;
    color = 'normal';
  } else if (systolic <= 139 || diastolic <= 89) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (systolic <= 159 || diastolic <= 99) {
    result = `${t('severe')}`;
    color = 'severe';
  } else if (systolic >= 160 || diastolic >= 100) {
    result = `${t('severe')}`;
    color = 'severe';
  }
  return { result, color };
};

export const RespirationRateLevel = (respirationRate, t) => {
  let result = '';
  let color = '';

  if (respirationRate > 21) {
    result = `${t('not_good')}`;
    color = 'notgood';
  } else if (respirationRate >= 12 && respirationRate <= 20) {
    result = `${t('normal')}`;
    color = 'normal';
  } else if (respirationRate < 11) {
    result = `${t('severe')}`;
    color = 'severe';
  }
  return { result, color };
};
